import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import TheWork from "@/components/site/TheWork";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Slate from "@/components/site/Slate";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import SmoothScroll from "@/components/SmoothScroll";

export default function Home() {
  return (
    <SmoothScroll>
      <div className="grain bg-alabaster relative">
        <Nav />
        <main>
          <Hero />
          <About />
          <TheWork />
          <EditorialMarquee />
          <Slate />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
